<template>
  <!-- Поля обёрнуты в <label> — связь с контролом есть и без id -->
  <!-- eslint-disable vuejs-accessibility/label-has-for -->
  <div class="w-toolbar">
    <div class="w-toolbar-group">
      <div class="w-tabs" aria-label="Календари">
        <button
          v-if="hasOwnCalendar"
          type="button"
          :aria-pressed="String(store.mode === 'mine')"
          @click="store.setMode('mine')"
        >
          Мой календарь
        </button>
        <button
          v-if="hasTeam"
          type="button"
          :aria-pressed="String(store.mode === 'team')"
          @click="store.setMode('team')"
        >
          Команда
        </button>
      </div>
      <label v-if="hasTeam && store.mode === 'team'" class="w-field w-staff-field">
        <span class="w-small">Календарь сотрудника</span>
        <select :value="store.staffId" @change="onStaffChange">
          <option v-for="doctor in store.editableDoctors" :key="doctor.id" :value="doctor.id">
            {{ doctor.name }}
          </option>
        </select>
      </label>
    </div>
    <div class="w-week-nav">
      <button
        class="w-button w-icon"
        type="button"
        aria-label="Предыдущая неделя"
        @click="store.shiftWeek(-1)"
      >
        <q-icon name="chevron_left" />
      </button>
      <span class="w-week-label">{{ weekLabel }}</span>
      <button
        class="w-button w-icon"
        type="button"
        aria-label="Следующая неделя"
        @click="store.shiftWeek(1)"
      >
        <q-icon name="chevron_right" />
      </button>
    </div>
  </div>

  <div class="w-view-row">
    <div class="w-view-fields">
      <label class="w-field w-date-field">
        Дата
        <input type="date" :value="store.date" @change="onDateChange" />
      </label>
      <span class="w-small w-hours-range">{{ hoursRange }}</span>
    </div>
    <div class="w-actions">
      <button
        class="w-button"
        type="button"
        :disabled="!store.canPlan"
        @click="store.selectRange(store.date, '13:00', '14:00')"
      >
        <q-icon name="touch_app" />
        Выбрать интервал
      </button>
      <button class="w-button" type="button" data-action="refresh" @click="store.loadSnapshot()">
        <q-icon name="refresh" />
        Обновить
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import { formatDate } from '~utils/calendarModel';

const store = useScheduleStore();

const hasOwnCalendar = computed(() => store.editableStaffIds.includes(Number(store.actorStaffId)));
const hasTeam = computed(() => store.editableStaffIds.length > 1);

// «5–11 октября 2026», на стыке месяцев — «26 октября–1 ноября 2026»
const weekLabel = computed(() => {
  const first = store.weekDays[0];
  const last = store.weekDays[store.weekDays.length - 1];
  const sameMonth = first.slice(0, 7) === last.slice(0, 7);
  const firstText = formatDate(first, sameMonth ? { day: 'numeric' } : { day: 'numeric', month: 'long' });
  const lastText = formatDate(last, { day: 'numeric', month: 'long', year: 'numeric' });
  return `${firstText}–${lastText.replace(' г.', '')}`;
});

const hoursRange = computed(() => {
  const { from, to } = store.viewHours;
  return from ? `Весь рабочий день · ${from}–${to}` : 'В выбранные даты филиал закрыт';
});

const onStaffChange = (event: Event) => {
  store.setStaff(Number((event.target as HTMLSelectElement).value));
};

const onDateChange = (event: Event) => {
  store.setDate((event.target as HTMLInputElement).value);
};
</script>
